import { INSTRUCTION } from '../constants/actionTypes'

const init = {
    testData: {},
}

export default (state = init, action) => {
    switch (action.type) {
        case INSTRUCTION:
            return {
                ...state,
                testData: action.payload ? action.payload : {},
            }
        default:
            return state
    }
}
